/**
 * Transforms object to URL params string.
 */
export const objectToURLParams = (object: Record<string, any>, separator = '&'): string => (
  Object.keys(object).map((key) => `${key}=${encodeURIComponent(object[key])}`).join(separator)
);
